import type { ExamSection, QuestionType } from '@examflow/core';
import { createSectionConstraint } from '@examflow/core';
import {
  ieltsListeningDefinition,
  ieltsReadingDefinition,
  ieltsWritingDefinition,
} from './questionTypes';

/**
 * IELTS 听力部分配置
 */
export const IELTS_LISTENING_SECTION: ExamSection = {
  id: 'listening',
  name: '听力 (Listening)',
  duration: 30,
  /** IELTS Academic / General Training listening: 40 items. */
  questionCount: 40,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(ieltsListeningDefinition.id)],
};

/**
 * IELTS 阅读部分配置
 */
export const IELTS_READING_SECTION: ExamSection = {
  id: 'reading',
  name: '阅读 (Reading)',
  duration: 60,
  /** IELTS Academic / General Training reading: 40 items. */
  questionCount: 40,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(ieltsReadingDefinition.id)],
};

/**
 * IELTS 写作部分配置
 */
export const IELTS_WRITING_SECTION: ExamSection = {
  id: 'writing',
  name: '写作 (Writing)',
  duration: 60,
  /** Two writing tasks (Task 1 + Task 2). */
  questionCount: 2,
  questionTypes: ['fill_blank' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(ieltsWritingDefinition.id)],
};

/**
 * IELTS 口语部分配置（单独考试）
 */
export const IELTS_SPEAKING_SECTION: ExamSection = {
  id: 'speaking',
  name: '口语 (Speaking)',
  duration: 11,
  /** Three speaking parts (interview / cue card / discussion). */
  questionCount: 3,
  questionTypes: ['fill_blank' as QuestionType],
};

/**
 * IELTS 考试部分（学术类）
 */
export const IELTS_SECTIONS: ExamSection[] = [
  IELTS_LISTENING_SECTION,
  IELTS_READING_SECTION,
  IELTS_WRITING_SECTION,
  IELTS_SPEAKING_SECTION,
];

/**
 * 获取总考试时长（分钟）
 */
export function getTotalDuration(): number {
  return IELTS_SECTIONS.reduce((sum, section) => sum + section.duration, 0);
}
